import { showToast } from 'shared/toast/showToast'
import ChangesSavedToast from 'src/routes/(registry)/list/[slug]/components/EditRegItemDrawer/components/ChangesSavedToast/ChangesSavedToast'

export const showChangesSavedToast = () =>
  showToast({
    render: (isOpen) => <ChangesSavedToast isOpen={isOpen} />,
    timeout: 5000,
  })
